import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TopMenuService {
    isAdminRoute$ = new BehaviorSubject<boolean>(false);

    get isAdminRoute () {
        return this.isAdminRoute$.value;
    }

    get isAdminRouteObs () {
        return this.isAdminRoute$.asObservable();
    }

    setAdminRoute (value: boolean) {
        this.isAdminRoute$.next(value);
    }
}
